<template>
  <div>
    <div
      class="container-title text-uppercase color_grey_dark font-weight-bold"
    >
      School Information
    </div>
    <!-- PARENT LIST COMPONENT -->
    <div v-if="school_name">
      <ListCard
        :card_image="school_image"
        :card_text_top="class_name"
        :card_text_bottom="school_name"
        :school_type="true"
      ></ListCard>
    </div>

    <div
      class="empty d-flex justify-content-start align-items-center nowrap"
      v-else
    >
      <div class="icon-info-details border_grey_dark font-20 mr-3"></div>
      <div class="font-14-5 border_grey_dark">
        Not Connected to a school yet!
      </div>
    </div>

    <!-- OPTION -->
    <div
      class="container-option mt-3 d-flex justify-content-start align-items-center nowrap"
      @click="toggleClassModal"
      v-if="!school_name"
    >
      <div class="avatar pointer border mr-2">
        <span class="flex-center icon-swap brand_accent font-17"></span>
      </div>
      <div
        class="label-text font-weight-bold brand_accent font-13-5 pointer btn-link"
      >
        Connect to school
      </div>
    </div>

    <!-- MODAL COMPS -->
    <ChangeClassModal
      v-if="class_modal"
      @updateSchool="fetchStudentClassDetails"
      @closeTriggered="toggleClassModal"
    ></ChangeClassModal>
    <!-- MODAL COMPS -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ListCard from "@/components/globalComps/SettingsComps/ProfileComps/ListCard";

export default {
  name: "ParentListContainer",

  components: {
    ListCard,
    ChangeClassModal: () =>
      import(
        /* webpackChunkName: "ChangeClassModal" */ "@/components/modalComps/studentModals/ChangeClassModal"
      ),
  },

  data() {
    return {
      school_image: "",
      school_name: "",
      class_name: "",
      class_modal: false,
    };
  },

  mounted() {
    this.fetchStudentClassDetails();
  },

  methods: {
    ...mapActions(["getStudentClassDetails"]),

    toggleClassModal() {
      this.class_modal = !this.class_modal;
    },

    fetchStudentClassDetails() {
      this.getStudentClassDetails()
        .then((response) => {
          if (response.code === 200) {
            this.school_image = response.data.school.logo;
            this.school_name = response.data.school.name;
            this.class_name = response.data.class.class_name;
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style lang="scss">
.container-title {
  margin-top: 30px;
  margin-bottom: 21px;
  font-size: 16px;
  line-height: 22px;

  @include breakpoint_max(sm) {
    font-size: 13.5px;
  }
}

.container-option {
  font-size: 14px;
  line-height: 19px;

  @include breakpoint_max(sm) {
    font-size: 12px;
  }
}
</style>
